import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import newsData from '../../data/news.json';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import './styles.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const News = () => {
  const [data, setData] = useState(newsData.news);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleClick = (tag) => {
    if (tag === 'すべて') {
      setData(newsData.news);
    } else {
      setData(newsData?.news.filter((d) => d.tag === tag));
    }
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>ニュース | 株式会社TERRA</title>
      </Helmet>
      <div className="news">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          ニュース
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>ニュース</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="news button mt-5">
            <div className="row">
              <div className="col-6 col-sm-3 pb-3">
                <button
                  style={{
                    width: '100%', height: '60px', backgroundColor: '#335171', color: 'white',
                  }}
                  onClick={() => handleClick('すべて')}
                  type="button"
                  className="btn"
                >
                  すべて
                </button>
              </div>
              <div className="col-6 col-sm-3">
                <button
                  style={{
                    width: '100%', height: '60px', backgroundColor: 'rgb(0,70,168)', color: 'white',
                  }}
                  onClick={() => handleClick('お知らせ')}
                  type="button"
                  className="btn"
                >
                  お知らせ
                </button>
              </div>
              <div className="col-6 col-sm-3">
                <button
                  style={{
                    width: '100%', height: '60px', backgroundColor: '#2eb0a6', color: 'white',
                  }}
                  onClick={() => handleClick('キャンペーン')}
                  type="button"
                  className="btn"
                >
                  キャンペーン
                </button>
              </div>
              <div className="col-6 col-sm-3">
                <button
                  style={{
                    width: '100%', height: '60px', backgroundColor: '#595f97', color: 'white',
                  }}
                  onClick={() => handleClick('メディア掲載')}
                  type="button"
                  className="btn"
                >
                  メディア掲載
                </button>
              </div>
            </div>
          </div>
          <div className="news news-list">
            <div style={{ minHeight: '50vh' }}>
              <ul style={{ listStyle: 'none', padding: '0', margin: '10vh 0' }}>
                {data.length > 0
                  ? (
                    data.map((news) => {
                      let color = '#595f97';
                      if (news?.tag === 'お知らせ') {
                        color = 'rgb(0,70,168)';
                      } else if (news?.tag === 'キャンペーン') {
                        color = '#2eb0a6';
                      } else {
                        color = '#595f97';
                      }
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <Link
                          key={news.id}
                          to={`/news/${news.id}`}
                          style={{
                            textDecoration: 'none',
                            lineHeight: '2',
                            marginBottom: '2rem',
                            display: 'block',
                          }}
                        >
                          <li className="news_item">
                            <span style={{ color: 'black', marginRight: '30px' }}>{news.date}</span>
                            <span
                              className="label"
                              style={{
                                backgroundColor: `${color}`, color: 'white', width: '120px', display: 'inline-block', textAlign: 'center', marginRight: '20px',
                              }}
                            >
                              {' '}
                              {news.tag}
                            </span>
                            <span
                              className="news news-item-title"
                              style={{ color: 'black', fontWeight: '600' }}
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{ __html: news.title }}
                            >
                              {/* {news.title} */}
                            </span>
                          </li>
                        </Link>
                      );
                    }))
                  : (
                    <div className="text-center">
                      <h4>ニュースがありません。</h4>
                    </div>
                  )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default News;
